import { IUserState } from '../../types/redux/user';

export const defaultState: IUserState = {
  userId: null,
  isM2Enabled: false,
};

export function userReducer(state: IUserState = defaultState) {
  return state;
}
